import { CircleCheck, CircleX, TriangleAlert } from "lucide-react";
import { evaluateRules, SETUP_RULES } from "@/shared/lib/raidRules";
import { cn } from "@/shared/lib/utils";
import type { SetupPlayer } from "../setup.types";

// Status colors are the documented exception to semantic tokens: error/warning/ok
// must read as red/orange/green regardless of theme.
export function RulesPanel({ players }: { players: SetupPlayer[] }) {
  const failures = evaluateRules(players, SETUP_RULES);
  const ok = failures.length === 0;

  return (
    <section className="space-y-1">
      {/* Heading stays mounted (just hidden when OK) so the box below always
          top-aligns with the role columns instead of floating up to the
          "Setup" heading row when there's nothing missing. */}
      <h2
        className={cn(
          "text-sm font-medium text-muted-foreground",
          ok && "invisible",
        )}
      >
        Saknar
      </h2>
      {ok ? (
        <div className="flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm text-emerald-500">
          <CircleCheck className="size-4" />
          Setup OK
        </div>
      ) : (
        <ul className="space-y-1 rounded-md border border-border p-3 text-sm">
          {failures.map((f) => (
            <li
              key={f.id}
              className={cn(
                "flex items-center gap-2",
                f.severity === "error" ? "text-red-500" : "text-amber-500",
              )}
            >
              {f.severity === "error" ? (
                <CircleX className="size-4 shrink-0" />
              ) : (
                <TriangleAlert className="size-4 shrink-0" />
              )}
              <span>{f.label}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
